import React from 'react';
import { RoleValidator } from './RoleValidator';
import { useHasRole } from '../hooks/useHasRole';
import { useFetch } from '../hooks/useFetch';
import { Box, BoxProps } from '@chakra-ui/react';
import { Selector } from './Selector';
import { AsyncSelector } from './AsyncSelector';
import { Branch } from '../domain/branch';
import { Role } from '../domain/Role';

type ParamsKeys = 'idMerchant' | 'idBranch';

interface MerchantBranchSelectorProps extends BoxProps {
  idMerchant: string[] | undefined;
  idBranch: string[] | undefined;
  handleUpdate: (key: ParamsKeys, value: string | undefined) => void;
}

interface FiltersResponse {
  merchants: {
    id: string;
    name: string;
  }[];
}

export const MerchantBranchSelector = ({ idBranch, idMerchant, handleUpdate, ...boxProps }: MerchantBranchSelectorProps) => {
  // El selector de comercio solo se renderiza para auditor (ver RoleValidator abajo), así
  // que la petición también se salta para el resto de los roles: antes se disparaba
  // igual aunque nunca se fuera a mostrar el resultado.
  const isAuditor = useHasRole([Role.auditor]);
  const { data, loading } = useFetch<FiltersResponse>('/transactions-view/filters', undefined, isAuditor);

  return <Box display="flex" flexWrap="wrap" rowGap="s" {...boxProps}>
    <RoleValidator allowedRoles={[Role.auditor]}>
      <Selector
        options={data?.merchants.map(item => ({ value: item.id, label: item.name })) || []}
        isMulti={true}
        placeholder="Selecciona un comercio"
        value={idMerchant}
        onChange={(e) => handleUpdate('idMerchant', e)}
        isLoading={loading}
        minWidth="15em"
        marginRight="l"
      />
    </RoleValidator>

    <RoleValidator allowedRoles={[Role.auditor, Role.branch_owner]}>
      <AsyncSelector<Branch>
        url="/transactions-view/branches"
        handleChange={(branches) => handleUpdate('idBranch', branches?.map(branch => branch.id) as any)}
        isMulti={true}
        value={idBranch}
        labelProperty="fantasy_name"
        idProperty="id"
        placeholder="Selecciona una sucursal"
        minWidth="15em"
      />
    </RoleValidator>
  </Box>;
};
